import {Text} from '@chakra-ui/react';
import {parseISO} from 'date-fns';
import {useFormDate, useTranslation} from 'hooks';
import {FC} from 'react';

interface Props {
  deliverTime: string;
  isPreorder?: boolean;
}

export const DeliverTime: FC<Props> = ({deliverTime, isPreorder}) => {
  const {t} = useTranslation();
  const {date: dateTime} = useFormDate(deliverTime, `${isPreorder ? 'HH:mm / dd.MM.yyyy' : 'HH:mm'}`);

  return (
    <Text>{`${t('DELIVERY_TIME')}: ${
      isPreorder
        ? dateTime
        : parseISO(deliverTime).toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: 'numeric',
            hour12: false,
            timeZone: 'Europe/Chisinau', // Set the timezone to Chisinau
          })
    }`}</Text>
  );
};
